import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/EquipmentReportActions";
import * as api from "../../api/EquipmentReportApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";


function* getEquipmentReportList() {
    try {
        const { data } = yield api.getEquipmentReportList();
        yield put(actions.setEquipmentReportList(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentReportList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addEquipmentReport(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addEquipmentReport(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateEquipmentReport(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateEquipmentReport(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteEquipmentReport(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteEquipmentReport(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_EQUIPMENT_REPORT_LIST, getEquipmentReportList);
    yield takeEvery(actions.Types.ADD_EQUIPMENT_REPORT, addEquipmentReport);
    yield takeEvery(actions.Types.UPDATE_EQUIPMENT_REPORT, updateEquipmentReport);
    yield takeEvery(actions.Types.DELETE_EQUIPMENT_REPORT, deleteEquipmentReport);
    yield takeEvery(actions.Types.GET_PLANTS, getPlants);
}

const equipmentReportSaga = [fork(watchAll)];

export default equipmentReportSaga;
